import React from 'react';
import './Introduction.scss';
import { useMediaQuery } from 'react-responsive';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

const Introduction = ({ strapiData }) => {
    const isSmallMobile = useMediaQuery({ maxWidth: 450 });
    return (
        <section className="introduction">
            <div className="introduction__profile">
                <div className="introduction__image-container">
                    <div className="introduction__image-wrapper">
                        <StrapiImageWithSkeleton
                            picture={strapiData.Intro_section.Photo}
                            loading="lazy"
                            size='small'
                        />
                    </div>
                    <div className="introduction__image-shadow"></div>
                </div>
                <div className="introduction__text">
                    {
                        isSmallMobile ?
                            <div className="" dangerouslySetInnerHTML={safeHtml(strapiData.Intro_section.TexteMobile)} />
                            :
                            <div className="" dangerouslySetInnerHTML={safeHtml(strapiData.Intro_section.Texte)} />
                    }
                </div>
            </div>
            <div className="introduction__part introduction__part1">
                <div className="introduction__content left-container">
                    <h2>{strapiData.Part1_section.Titre}</h2>
                    <div className="introduction__text-block" dangerouslySetInnerHTML={safeHtml(strapiData.Part1_section.Texte1)} />
                </div>
                <div className="introduction__image-container">
                    <div className="introduction__image-wrapper">
                        <StrapiImageWithSkeleton
                            picture={strapiData.Part1_section.Photo1}
                            loading="lazy"
                            size='small'
                        />
                    </div>
                    <div className="introduction__image-shadow"></div>
                </div>
            </div>
            <div className="introduction__part introduction__part2">
                <div className="introduction__image-container left-container">
                    <div className="introduction__image-wrapper">
                    <StrapiImageWithSkeleton
                            picture={strapiData.Part1_section.Photo2}
                            loading="lazy"
                            size='small'
                        />
                    </div>
                    <div className="introduction__image-shadow"></div>
                </div>
                <div className="introduction__content">
                <div className="introduction__text-block" dangerouslySetInnerHTML={safeHtml(strapiData.Part1_section.Texte2)} />
                </div>
            </div>
            <div className="introduction__part3__container">
                <div className="introduction__part introduction__part3">
                    <div className="introduction__content">
                    <div className="introduction__text-block" dangerouslySetInnerHTML={safeHtml(strapiData.Part2_section.Texte)} />
                    </div>
                    <div className="introduction__part3-images-container">
                        <div className="introduction__image-container introPart3_1">
                            <div className="introduction__image-wrapper">
                            <StrapiImageWithSkeleton
                                picture={strapiData.Part2_section.Photo1}
                                loading="lazy"
                                size='small'
                            />
                            </div>
                            <div className="introduction__image-shadow"></div>
                        </div>
                        <div className="introduction__image-container introPart3_2">
                            <div className="introduction__image-wrapper">
                                <StrapiImageWithSkeleton
                                    picture={strapiData.Part2_section.Photo2}
                                    loading="lazy"
                                    size='small'
                                />
                            </div>
                            <div className="introduction__image-shadow"></div>
                        </div>
                        <div className="introduction__image-container introPart3_3">
                            <div className="introduction__image-wrapper">
                                <StrapiImageWithSkeleton
                                    picture={strapiData.Part2_section.Photo3}
                                    loading="lazy"
                                    size='small'
                                />
                            </div>
                            <div className="introduction__image-shadow"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="introduction__part introduction__part4">
                <div className="introduction__image-container left-container">
                    <div className="introduction__image-wrapper">
                        <StrapiImageWithSkeleton
                            picture={strapiData.Part3_section.Photo}
                            loading="lazy"
                            size='small'
                        />
                    </div>
                    <div className="introduction__image-shadow"></div>
                </div>
                <div className="introduction__content">
                <div className="introduction__text-block" dangerouslySetInnerHTML={safeHtml(strapiData.Part3_section.Texte)} />
                </div>
            </div>
        </section>
    );
};

export default Introduction;